import React from "react";
import { Drawer, Row, Col, Divider, Typography, Table, Tag } from "antd";
import { isMobile } from "react-device-detect";
import ReactHtmlParser from "react-html-parser";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Text, Paragraph, Title } = Typography;

const TreatmentSessionDetail = ({ visible, onClose, record }) => {
    if (!record) return null;

    const procedureColumns = [
        { title: "Tên thủ thuật", dataIndex: "name", key: "name", width: "300px" },
        {
            title: "Nội dung",
            dataIndex: "description",
            key: "description",
            render: (text) => (
                <Paragraph style={{ whiteSpace: "pre-line", marginBottom: 0 }}>
                    {text}
                </Paragraph>
            ),
        },
    ];

    const serviceColumns = [
        { title: "Mã", dataIndex: ["service", "code"], key: "code", width: 120 },
        { title: "Tên dịch vụ", dataIndex: ["service", "name"], key: "name" },
        {
            title: "Giá",
            dataIndex: ["service", "price"],
            key: "price",
            width: 150,
            render: (price) =>
                price
                    ? price.toLocaleString("vi-VN", {
                        style: "currency",
                        currency: "VND",
                    })
                    : null,
        },
    ];

    return (
        <Drawer
            visible={visible}
            title={`Chi tiết phiếu điều trị #${record.id}`}
            onClose={onClose}
            width={isMobile ? "100%" : "80%"}
            maskClosable={false}
        >
            {/* Thông tin cơ bản */}
            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Text strong>Cơ sở:</Text>{" "}
                    <Text>{record?.branche?.name}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text strong>Lần khám:</Text>{" "}
                    <Text>
                        {record.lan_kham === "dieu_tri_moi" ? "Điều trị mới" : "Tái khám"}
                    </Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text strong>Bác sĩ phụ trách:</Text>{" "}
                    <div>
                        {record.doctors && record.doctors.length > 0 &&
                            record.doctors.map((a, i) => (
                                <div key={i}>
                                    <span style={{ color: '#999' }}>{a.doctor?.user_role?.name}: </span>
                                    <span style={{ fontWeight: 400 }}>{a.doctor?.full_name}</span>
                                </div>
                            ))
                        }
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <Text strong>Y tá phụ trách:</Text>{" "}
                    <div>
                        {record.assistants && record.assistants.length > 0 &&
                            record.assistants.map((a, i) => (
                                <div key={i}>
                                    <span style={{ color: '#999' }}>{a.assistant?.user_role?.name}: </span>
                                    <span style={{ fontWeight: 400 }}>{a.assistant?.full_name}</span>
                                </div>
                            ))
                        }
                    </div>
                </Col>
                <Col xs={24} md={12}>
                    <Text strong>Ngày điều trị:</Text> <Text>{record.ngay}</Text>
                </Col>
                <Col xs={24} md={12}>
                    <Text strong>Trạng thái xác nhận:</Text>{" "}
                    {record.is_approved ? (
                        <div>
                            <Tag icon={<CheckCircleOutlined />} color="success">
                                Đã xác nhận
                            </Tag>
                            <div style={{ fontSize: 12, marginTop: 4 }}>
                                <div>
                                    <span style={{ color: "#999" }}>
                                        {record?.approved_by?.user_role?.name || "Người xác nhận"}:
                                    </span>{" "}
                                    <span style={{ fontWeight: 500 }}>
                                        {record?.approved_by?.full_name}
                                    </span>
                                </div>
                                <div style={{ color: "#999" }}>
                                    Lúc: {record.approved_at}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Tag icon={<CloseCircleOutlined />} color="error">
                            Chưa xác nhận
                        </Tag>
                    )}
                </Col>
            </Row>

            <Divider />

            <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Text strong>Ghi chú nội bộ:</Text>
                    <Paragraph>{ReactHtmlParser(record.ghi_chu_noi_bo)}</Paragraph>
                </Col>
            </Row>

            <Divider orientation="left" orientationMargin={0}>CÁC ĐIỀU TRỊ / THỦ THUẬT</Divider>
            <Row gutter={16}>
                <Col span={24}>
                    <Title level={5}>Dịch vụ</Title>
                    <Table
                        rowKey="id"
                        dataSource={record.services || []}
                        columns={serviceColumns}
                        pagination={false}
                        bordered
                        size="small"
                        locale={{ emptyText: "Chưa có dịch vụ" }}
                    />
                </Col>
                <Col span={24} style={{ marginTop: 16 }}>
                    <Title level={5}>Thủ thuật</Title>
                    <Table
                        rowKey="id"
                        dataSource={record.procedures || []}
                        columns={procedureColumns}
                        pagination={false}
                        bordered
                        size="small"
                        locale={{ emptyText: "Chưa có thủ thuật" }}
                    />
                </Col>
            </Row>

            <Divider orientation="left" orientationMargin={0}>ĐƠN THUỐC</Divider>
            <Row gutter={16}>
                <Col span={24}>
                    <Paragraph style={{ whiteSpace: "pre-line" }}>
                        {ReactHtmlParser(record.don_thuoc)}
                    </Paragraph>
                </Col>
            </Row>

            <Divider orientation="left" orientationMargin={0}>LỜI DẶN</Divider>
            <Row gutter={16}>
                <Col span={24}>
                    <Paragraph style={{ whiteSpace: "pre-line" }}>
                        {ReactHtmlParser(record.loi_dan)}
                    </Paragraph>
                </Col>
            </Row>
            <Divider />
            <Text type="secondary">
                Tạo bởi {record.created_user?.full_name} lúc {record.created_at}
            </Text>
        </Drawer>
    );
};

export default TreatmentSessionDetail;
